/*
    玉山Wallet用
 */
const state = () => ({
    huid: null, 
    token: null,
    cid: null,
    iData: null,
    txToken: null,
    cardHolder: null,
  });
  
  const actions = {};
  
  const getters = {};
  
  const mutations = {
    /**
     * 會員識別碼
     * @param {*} state
     * @param {*} payload
     */
    setHuid(state, payload) {
      state.huid = payload;
    },
    /**
     * 資料交換token
     * @param {*} state
     * @param {*} payload
     */
    setToken(state, payload) {
      state.token = payload;
    },
    /**
     * 身分證字號
     * @param {*} state
     * @param {*} payload
     */
    setCid(state, payload) {
        state.cid = payload;
      },
    /**
     * 加密資料(AES256加密的JSON字串)
     * @param {*} state
     * @param {*} payload
     */
    setiData(state, payload) {
        state.iData = payload;
      },
      /**
       * 交易token
       * @param {*} state
       * @param {*} payload
       */
    setTxToken(state, payload) {
      state.txToken = payload;
    },
    /**
     * 持卡人ID
     * @param {*} state
     * @param {*} payload
     */
    setCardHolder(state, payload) {
      state.cardHolder = payload;
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  